(function () {
  if (typeof window.ShambhalaMaterialStory !== 'undefined') return;

  class ShambhalaMaterialStory {
    constructor(root) {
      this.root = root;
      this.chapters = Array.from(root.querySelectorAll('[data-sms-chapter]'));
      this.navButtons = Array.from(root.querySelectorAll('[data-sms-nav]'));
      this.activeIndex = 0;

      if (!this.chapters.length) return;

      this.bindNav();
      this.setActive(0, false);
    }

    bindNav() {
      this.navButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.smsNav);
          this.setActive(index, true);
        });
      });
    }

    setActive(index, animate) {
      if (index === this.activeIndex && animate) return;

      this.activeIndex = index;

      this.chapters.forEach((chapter, i) => {
        const isActive = i === index;
        chapter.classList.toggle('is-active', isActive);
        chapter.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          chapter.removeAttribute('hidden');
        } else {
          chapter.setAttribute('hidden', '');
        }
      });

      this.navButtons.forEach((button, i) => {
        const isActive = i === index;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.refreshLazyImages();
    }

    refreshLazyImages() {
      const activeChapter = this.chapters[this.activeIndex];
      if (!activeChapter) return;

      window.requestAnimationFrame(() => {
        if (window.lazySizes && typeof window.lazySizes.loader === 'object') {
          window.lazySizes.loader.checkElems();
        }

        activeChapter.querySelectorAll('img.lazyload:not(.lazyloaded)').forEach((img) => {
          if (window.lazySizes && typeof window.lazySizes.loader === 'object' && typeof window.lazySizes.loader.unveil === 'function') {
            window.lazySizes.loader.unveil(img);
          } else if (img.dataset.src && !img.getAttribute('src')) {
            img.setAttribute('src', img.dataset.src);
          }
        });
      });
    }
  }

  window.ShambhalaMaterialStory = ShambhalaMaterialStory;

  function initAll() {
    document.querySelectorAll('[data-shambhala-material-story]').forEach((root) => {
      if (root.__smsInstance) return;
      root.__smsInstance = new ShambhalaMaterialStory(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section) {
      initAll();
      return;
    }
    section.querySelectorAll('[data-shambhala-material-story]').forEach((root) => {
      root.__smsInstance = null;
      root.__smsInstance = new ShambhalaMaterialStory(root);
    });
  });
})();
